import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'utils/formatUtils';

import {
  newCalculationStarted,
  historyCountSelector,
  historyMetricsSelector,
  currentMetricsSelector
} from 'redux/historySlice';
import useWizardNavigation from 'hooks/useWizardNavigation';

import MetricsTable from './MetricsTable';
import LicenseCalculatorModal from '../LicenseCalculator';
import NavigationButtons from 'components/NavigationButtons';

import {
  StyledMetricsContainer,
  StyledTableContainer,
  StyledButton,
  StyledPlusIcon,
  StyledCheckIcon
} from './ViewMetricsStep-styled';
import {
  StyledCardContainer,
  StyledActiveCard,
  StyledCardTitle,
  StyledCardText,
  Heading
} from 'components/StyledComponents';

const ViewMetricsStep: React.FC = () => {
  const [isDone, setDone] = useState(false);
  const dispatch = useDispatch();
  const metrics = useSelector(currentMetricsSelector);
  const historyMetrics = useSelector(historyMetricsSelector);
  const historyCount = useSelector(historyCountSelector);
  const { previous } = useWizardNavigation();

  const { numberOfFeatures, averageSizeOfFeaturesBytes } = metrics;

  if (isDone && historyCount === 1) {
    return (
      <StyledTableContainer>
        <MetricsTable metrics={historyMetrics[0]} />
        <StyledButton appearance="outline-fill" onClick={() => setDone(false)}>
          Back
        </StyledButton>
      </StyledTableContainer>
    );
  }

  return (
    <>
      {isDone && (
        <LicenseCalculatorModal
          metricsCollection={[...historyMetrics]}
          onRequestClose={() => setDone(false)}
        />
      )}
      <StyledMetricsContainer>
        <Heading>
          The sampled data includes {numberOfFeatures} feature
          {numberOfFeatures > 1 ? 's' : ''} with an average size of{' '}
          {format(averageSizeOfFeaturesBytes)} bytes.
        </Heading>
        <StyledCardContainer>
          <StyledActiveCard onClick={() => dispatch(newCalculationStarted())}>
            <StyledPlusIcon />
            <StyledCardTitle>Add Calculation</StyledCardTitle>
            Complete another calculation and add the metrics to the end result
          </StyledActiveCard>
          <StyledActiveCard onClick={() => setDone(true)}>
            <StyledCheckIcon />
            <StyledCardTitle>Retrieve Final Metrics</StyledCardTitle>
            <StyledCardText>
              Show feature rates and subscription limits
            </StyledCardText>
          </StyledActiveCard>
        </StyledCardContainer>
      </StyledMetricsContainer>
      <NavigationButtons onPrevious={previous}></NavigationButtons>
    </>
  );
};

export default ViewMetricsStep;
